import React, { useState } from "react";
import trans from "../../../../utils";
import TrackedSelectedDetails from "./TrackedSelectedDetails";
import TrackedSelectedStatus from "./TrackedSelectedStatus";
import TrackedSelectedSensors from "./TrackedSelectedSensors";
import TrackedSelectedControls from "./TrackedSelectedControls";
import TrackedSelectedCamera from "./TrackedSelectedCamera";
import TrackedSelectedQuickActions from "./TrackedSelectedQuickActions";
import Button from "../../../Helpers/Button/Button";

export default function TrackedSelectedTabs({
	title,
	img,
	values,
	device,
	position,
	CarSensors,
	showmore,
	setShowmore,
	show,
}) {
	const [openDropdown, setOpenDropdown] = useState(null);
	const toggleDropdown = (name) => {
		setOpenDropdown(openDropdown === name ? null : name);
	};
	const lang = localStorage.getItem("lang") || "en";
	return (
		<>
			<div className="object-body-title" onClick={() => toggleDropdown(title)}>
				<div className="flex-between">
					<div className={`${lang === "en" ? "mr-16" : "ml-16"}`}>
						<img src={`${process.env.PUBLIC_URL}/assets/${img}.svg`} alt="" />
					</div>
					<div className="fs-16 fw-600" role="button">
						{trans(title)}
					</div>
				</div>
			</div>

			<div>
				{title === "Vehicle Details" && (
					<>
						<TrackedSelectedDetails
							device={device}
							details={values}
							position={position}
						/>
						<TrackedSelectedQuickActions device={device} details={values} />
						{!showmore && (
							<div style={{ padding: "12px" }}>
								<Button
									className="default"
									text={trans("More Actions")}
									style={{ display: "flex", margin: "auto", width: "100%" }}
									onClick={() => setShowmore(true)}
								/>
							</div>
						)}
					</>
				)}

				{title === "working status" && (
					<TrackedSelectedStatus
						details={values}
						device={device}
						position={position}
					/>
				)}
				{title === "sensors" && (
					<TrackedSelectedSensors position={position} CarSensors={CarSensors} />
				)}
				{title === "controls" && (
					<TrackedSelectedControls device={device} values={values} />
				)}
				{title === "camera" && <TrackedSelectedCamera />}
			</div>
		</>
	);
}
